import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DollarDocumentPlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DollarDocumentPlusIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DollarDocumentPlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarDocumentPlusIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="DollarDocumentPlusIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M16.03 2L21 7.075V12h-2V7.891L15.19 4H5v16l7-.001V22H5a2 2 0 01-2-2V4a2 2 0 012-2h11.03zM19 14v3h3v2h-3v3h-2v-3.001L14 19v-2l3-.001V14h2zm-7-7v1h2v2h-4v1h3a1 1 0 01.993.883L14 12v3a1 1 0 01-.883.993L13 16h-1v1h-2v-1H8v-2h4v-1H9a1 1 0 01-.993-.883L8 12V9a1 1 0 01.883-.993L9 8h1V7h2z"
        clipRule="evenodd"
      />
    </svg>
  )
);
DollarDocumentPlusIcon.displayName = "DollarDocumentPlusIcon";
export default DollarDocumentPlusIcon;
